var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { validateEmail } from '../../common';
import { isNotIncludedEmailDomain, isRequiredText, strMax } from '../../utils';
import { validateShareStatus } from '../proffit_search/proffit_search_common_validate';
/**
 * 共有対象のメールアドレスで非同期でバリデーションを実行（スライド一覧/詳細用）
 * @param formValues
 * @param dispatch
 * @param formProps
 * @param fieldName
 * @returns {Promise<void>}
 */
const asyncShareSlideEmailValidate = (formValues, dispatch, formProps, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const { syncErrors, unmountRef } = formProps;
    const emails = formValues.shareEmail || [];
    const promiseList = emails
        .filter((unused, i) => !(syncErrors.shareEmail || [])[i])
        .map(({ email }) => validateShareStatus(dispatch, email, fieldName));
    const result = yield Promise.all(promiseList);
    if (unmountRef.current) {
        return;
    }
    const errorObj = { shareEmail: [] };
    result
        .filter((v) => v.error)
        .forEach((v) => {
        const index = emails.findIndex(({ email }) => email === v.email);
        errorObj.shareEmail[index] = { email: v.error };
    });
    if (Object.keys(errorObj).length > 0) {
        throw errorObj;
    }
});
/**
 * 共有対象のメールアドレスで非同期でバリデーションを実行（スライド追加用）
 * @param formValues
 * @param dispatch
 * @param formProps
 * @param fieldName
 * @returns {Promise<void>}
 */
const asyncAddSlideEmailValidate = (formValues, dispatch, formProps, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const { syncErrors, unmountRef } = formProps;
    const { slides = [] } = formValues;
    const errorObj = {
        slides: slides.map((slide) => ({
            shareEmail: slide.shareEmail.map(() => undefined),
        })),
    };
    for (let slideIndex = 0; slideIndex < slides.length; slideIndex += 1) {
        const emails = slides[slideIndex].shareEmail || [];
        const promiseList = emails
            .filter((unused, emailIndex) => {
            const { shareEmail: shareEmailError = [] } = (syncErrors.slides || [])[slideIndex] || {};
            return !shareEmailError[emailIndex];
        })
            .map(({ email }) => validateShareStatus(dispatch, email, fieldName));
        // eslint-disable-next-line no-await-in-loop
        const result = yield Promise.all(promiseList);
        //
        if (!unmountRef.current) {
            result
                .filter((v) => v.error)
                .forEach((v) => {
                const emailIndex = emails.findIndex(({ email }) => email === v.email);
                errorObj.slides[slideIndex].shareEmail[emailIndex] = {
                    email: v.error,
                };
            });
        }
    }
    const hasError = errorObj.slides.some((slide) => slide.shareEmail.some((v) => v && v.email));
    if (hasError) {
        throw errorObj;
    }
});
export const validateShare = {
    addForm: (formValues, dispatch, formProps, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        if (fieldName &&
            fieldName.match(/slides\[\d+?]\.shareEmail\[\d+?]\.email/)) {
            yield asyncAddSlideEmailValidate(formValues, dispatch, formProps, fieldName);
        }
    }),
    shareEmail: [
        ...validateEmail,
        (value, record, props) => {
            const { enableDomains } = props;
            return isNotIncludedEmailDomain(enableDomains, 'ドメインが異なるメールアドレスは登録できません')(value);
        },
        (value, record, props) => {
            const { profile = {} } = props;
            const { email: selfEmail } = profile;
            return selfEmail === value ? '自身のメールアドレスは入力できません' : '';
        },
    ],
    shareEmailList: [isRequiredText('共有先を入力してください')],
    shareForm: (formValues, dispatch, formProps, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        if (fieldName && fieldName.match(/shareEmail\[\d+?]\.email/)) {
            yield asyncShareSlideEmailValidate(formValues, dispatch, formProps, fieldName);
        }
    }),
    shareMemo: [strMax(2000, 'メッセージは2000文字以内で入力してください')],
};
export default validateShare;
